export default function NoPage() {
  return (
    <>
      <h2>Error 404: Page Not found</h2>
    </>
  );
}
